module.exports = __webpack_public_path__ + "static/media/logo_habi.2424795f.jpg";